import { createFileRoute } from '@tanstack/react-router';
import EmployeeManagement from '../../components/manager/EmployeeManagement';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/employees')({
  component: EmployeeManagementRoute,
});

function EmployeeManagementRoute() {
  return (
    <ManagerPortal>
      <EmployeeManagement />
    </ManagerPortal>
  );
}
